import { useDeviceType } from '@cian/ui-kit';
import { useMemo } from 'react';

import { Header } from 'shared/components/Header';
import { useApplicationContext } from 'shared/utils/applicationContext';
import { mapRemoteSocials } from 'shared/utils/socials/mapRemoteSocials';
import type { TRemoteSocial } from 'shared/types/socials';

export const HeaderContainer: React.FC = () => {
  const { config } = useApplicationContext();
  const device = useDeviceType();

  const remoteSocials = config.get<TRemoteSocial[]>('b2b-marketing-smb-promo-frontend.socials');

  const socialItems = useMemo(() => mapRemoteSocials(remoteSocials, device), [remoteSocials, device]);

  return <Header socialItems={socialItems} device={device} />;
};
